import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-dropdown-select';

import { ENTER } from '../../constants/keyboardCodes';

import '../../stylesheets/lc.scss';

const FormSelection = ({ message, options, onChange, placeholder }) => (
    <div className="form-container">
        <p className="form-message">{message}</p>
        <Select
            closeOnSelect
            dropdownGap={0}
            searchable={false}
            handleKeyDownFn={({ event, setState }) => {
                const key = event.which || event.keyCode;
                if (key === ENTER) {
                    setState({ dropdown: true });
                }
            }}
            dropdownHandleRenderer={({ state }) => (
                <span className={`dropdown-icon ${state.dropdown ? 'opened' : 'closed'}`} />
            )}
            className="form-dropdown"
            options={options}
            onChange={(v)=>onChange(v[0])}
            placeholder={placeholder}
        />
    </div>
);

FormSelection.propTypes = {
    message: PropTypes.string,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
};

FormSelection.defaultProps = {
    message: '',
    placeholder: '',
};

export default FormSelection;
